import { message } from 'antd'

import { fetchUtil as fetch } from 'src/utils/fetch'
import { saveAuditData } from 'src/api/audit'

export const saveState = async (record, state, sendEmail = false) => {
  try {
    const { data } = await fetch(
      `/marketplace/users/state/${record.id}/${state}?sendEmail=${sendEmail}`,
      {
        method: 'PATCH',
        headers: {
          role: 'ADMIN',
        },
      }
    )
    saveAuditData(
      'EDIT',
      'REDEEMUSER',
      JSON.stringify({
        name: record.name,
        username: record?.userName,
        userId: record?.userId,
        state: state,
        marketPlaceName: record?.marketPlaceName,
      })
    )
    return data
  } catch (e) {
    message.error('Save State Error !')
  }
}

export const getDelayStatus = async () => {
  try {
    const { data } = await fetch(`/marketplace/users/status`)
    return data
  } catch (e) {
    message.error('Save State Error !')
  }
}

export const saveStatus = async (record, status, reason) => {
  try {
    const requestBody: {
      id: string
      status: string
      reason: string
    } = { id: record.id, status, reason }

    const { data } = await fetch(`/marketplace/users/status`, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        role: 'ADMIN',
      },
    })
    saveAuditData(
      'EDIT',
      'REDEEM-USER-STATUS',
      JSON.stringify({
        name: record.name,
        status: status,
        reason: reason,
        username: record?.userName,
        userId: record?.userId,
        marketPlaceName: record?.marketPlaceName,
      })
    )

    return data
  } catch (e) {
    message.error('Save Status Error !')
  }
}

export const saveValidationStatus = async (record, state) => {
  try {
    const requestBody: {
      id: string
      state: string
    } = { id: record.id, state }

    const { data } = await fetch(
      `/marketplace/users/${record.id}/validation-status/${state}`,
      {
        method: 'PATCH',
        body: JSON.stringify(requestBody),
        headers: {
          role: 'ADMIN',
        },
      }
    )
    saveAuditData(
      'EDIT',
      'REDEEM-VALIDATION-STATUS',
      JSON.stringify({
        username: record?.userName,
        state: state,
        marketPlaceName: record?.marketPlaceName,
      })
    )

    return data
  } catch (e) {
    console.log('e', e)
    message.error(e?.error)
  }
}

export const getDashBoard = async (
  providerCountry = '',
  productId = '',
  fromDate,
  toDate
) => {
  const requestBody: {
    providerCountry?: string
    productId?: string
    fromDate: string
    toDate: string
  } = { fromDate, toDate }

  if (providerCountry != null || providerCountry != '') {
    requestBody.providerCountry = providerCountry
  }

  if (productId != null || productId != '') {
    requestBody.productId = productId
  }

  const { data } = await fetch(`/report/redeem-user/dashboard`, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      role: 'ADMIN',
    },
  })
  return data
}

export const editPointSupply = async (points, userId, now) => {
  const requestBody: {
    points: number
    now: string
    userId: string
  } = { points, now, userId }

  const { data } = await fetch(`/report/redeem-user/edit/supply-points`, {
    method: 'PATCH',
    body: JSON.stringify(requestBody),
    headers: {
      role: 'ADMIN',
    },
  })

  saveAuditData(
    'EDIT',
    'REDEEM-POINT-SUPPLY',
    JSON.stringify({
      points: points,
      time: now,
    })
  )
  return data
}

export const getMarketplaces = async () => {
  try {
    const { data } = await fetch(`/report/marketplace`)
    return data
  } catch (e) {
    message.error('Get Marketplaces Error!')
  }
}

export const saveBulkEdit = async (ids, state, sendEmail = false) => {
  try {
    const { data } = await fetch(`/marketplace/users/state/bulk-update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ids: ids, state: state, sendEmail: sendEmail }),
    })
    saveAuditData('BULK-EDIT', 'REDEEM_USERS', JSON.stringify({ state: state }))
    return data
  } catch (e) {
    console.log('Updated Successfully!')
  }
}
